import { ClassNames } from "@emotion/react";
import { FC } from "react";

import { DesignToken, IPickerListItem, Picker, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { ICannedResponse } from "store/entities/canned-responses";
import { textEllipsisStyles } from "styles/common";
import { withVar } from "themes/helpers";
import { KeyMap } from "utils/interface";

import { CannedResponsePreview } from "./CannedResponsePreview";
import { cannedTextStyles, pickerZIndexStyles } from "./styles";

interface IProps {
  cannedResponses: KeyMap<ICannedResponse>;
  onChange: (cannedResponse: ICannedResponse | null) => void;
  value?: ICannedResponse;
  disabled?: boolean;
  placeholder?: string;
  testId?: string;
}

const CannedResponseOption: FC<{ cannedResponse: ICannedResponse }> = ({ cannedResponse }) => (
  <Flex column>
    <span css={textEllipsisStyles}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {cannedResponse.shortcuts.map((shortcut: any) => (
        <span key={`${cannedResponse.id}#${shortcut}`}>
          <Text
            as="span"
            css={{
              color: withVar(DesignToken.ActionPrimaryDefault),
            }}
            bold
          >
            #&nbsp;
          </Text>
          <Text as="span" bold>
            {shortcut}
          </Text>{" "}
        </span>
      ))}
    </span>
    <Text css={cannedTextStyles}>{cannedResponse.text}</Text>
  </Flex>
);

const getPickerOption = (cannedResponse: ICannedResponse): IPickerListItem => ({
  key: cannedResponse.id,
  name: cannedResponse.shortcuts.join().concat(cannedResponse.text),
  customElement: {
    listItemBody: <CannedResponseOption cannedResponse={cannedResponse} />,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectedItemBody: <Text>{cannedResponse.shortcuts.map((s: any) => `#${s}`).join(" ")}</Text>,
  },
});

export const CannedResponsePicker: FC<IProps> = ({ cannedResponses, onChange, value, placeholder, testId }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onSelect = (option?: IPickerListItem[] | null) => {
    if (!option) {
      return;
    }
    onChange(cannedResponses[option[0].key]);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onClear = () => {
    onChange(null);
  };

  const options = Object.values(cannedResponses).map(getPickerOption);
  return (
    <>
      <div
        onClick={event => {
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        <ClassNames>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {({ css }: any) => (
            <Picker
              options={options}
              onSelect={onSelect}
              placeholder={placeholder}
              hideClearButton
              disabled={!!value}
              selected={value ? [getPickerOption(value)] : []}
              listClassName={css(pickerZIndexStyles)}
              data-testid={testId}
            />
          )}
        </ClassNames>
      </div>
      {value && <CannedResponsePreview cannedResponse={value} onClear={onClear} />}
    </>
  );
};
